import { render, staticRenderFns } from "./ShopSteps.vue?vue&type=template&id=5b12d436"
import script from "./ShopSteps.vue?vue&type=script&lang=js"
export * from "./ShopSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports